import React from "react";
import styles from "./ui.module.css";

const Button = ({ label, onClick, isSaving = false, isSavingLabel = "" }) => {
    return (
        <button
            type="submit"
            disabled={isSaving}
            className={styles.submitButton}
            onClick={onClick}
        >
            {isSaving ? (
                <div className={styles.savingContent}>
                    <span>{isSavingLabel}</span>
                    <div className={styles.loadingSpinner}></div>
                </div>
            ) : (
                label 
            )}
        </button>
    );
};

export default Button;